<template>
	<ContentBrowser v-bind:isEditable="false" v-bind:isDraggable="true"/>
</template>

<script>
	import ContentBrowser from '@/components/content/ContentBrowser.vue'

	export default {
		name: "ShowEditContent",
		components: {
			ContentBrowser
		}
	}
</script>

<style scoped>

</style>